import { NavMenus } from "./nav-menus";
import * as Styled from "./style";

export const DmmMenu = () => {
  return (
    <Styled.DivWrapper>
      <NavMenus />
    </Styled.DivWrapper>
  );
};
